import { NvIconModule } from 'Src/nvps-libraries/design/nv-icon/nv-icon.module';
import { CommonModule } from '@angular/common';
import { PanelListComponent } from './panel-list.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [PanelListComponent],
  imports: [CommonModule, NvIconModule],
  exports: [PanelListComponent],
  providers: [],
})
export class PanelListModule {}
